import { useState, useEffect } from "react";
import { CartModel } from "atoms/models";
import CalendarButton from "./CalendarButton";
import { OPTION_PRO_INSTALL, OPTION_STORE_PICKUP, OPTION_SHIP, SCHEDULE_TYPE_NON_SECURITY, SCHEDULE_TYPE_SECURITY } from "utils/const";
import ShippingAddressForm from "./ShippingAddressForm";
import { useRecoilState } from "recoil";
import { scheduleState } from "atoms";
import { emptyScheduleObject } from "components/Schedule/Input";
import StorePickupModal from "./StorePickupModal";
import { gtmInstallationType } from "utils/googleTagManager";

const ScheduleRadioButtons: React.FC<{ cart: CartModel; appointments: any }> = ({ cart, appointments }) => {
  const [optionRadio, setOptionRadio] = useState("");
  const [showStorePickupModal, setStorePickupModal] = useState(false);
  const [schedule, setSchedule] = useRecoilState(scheduleState);

  useEffect(() => {
    if (schedule.optionSelected === OPTION_PRO_INSTALL) {
      setOptionRadio(OPTION_PRO_INSTALL);
    } else if (schedule.optionSelected === OPTION_SHIP) {
      setOptionRadio(OPTION_SHIP);
    } else if (schedule.optionSelected === OPTION_STORE_PICKUP) {
      setOptionRadio(OPTION_STORE_PICKUP);
    } else {
      return;
    }
  }, [schedule.optionSelected]);

  const resetScheduleState = (option: string) => {
    let selectedOption;
    if (option === OPTION_PRO_INSTALL) {
      selectedOption = {
        ...emptyScheduleObject,
        optionSelected: option,
        installationTextNumber: cart.phoneNumber,
        billCycle: cart.billCycle,
      };
      setSchedule(selectedOption);
    } else if (option === OPTION_SHIP) {
      selectedOption = {
        ...emptyScheduleObject,
        optionSelected: option,
        shippingAddress: {
          apartmentNumber: cart.billingApartmentNumber,
          city: cart.billingCity,
          state: cart.billingState,
          streetName: cart.billingStreetName,
          streetNumber: cart.billingStreetNumber,
          zipCode: cart.billingZipCode,
        },
        installationTextNumber: cart.phoneNumber,
        billCycle: cart.billCycle,
      };
      setSchedule(selectedOption);
    } else if (option === OPTION_STORE_PICKUP) {
      selectedOption = {
        ...emptyScheduleObject,
        optionSelected: option,
        installationTextNumber: cart.phoneNumber,
        billCycle: cart.billCycle,
      };
      setSchedule(selectedOption);
    }
  };

  return (
    <>
      <div className='schedule-radio-container'>
        <div className='subheader'>
          <p>
            <strong>Please choose an installation option below:</strong>
          </p>
          <p>You can do it yourself or we can send a professional to do it for you.</p>
        </div>
        {cart.requiresModemUpgrade ? (
          <div className='upgrade-modem-message'>
            <p>
              <strong>PLEASE NOTE:</strong>
            </p>
            <p>Your current modem will not support the speeds you are requesting. A new modem is needed for your upgrade.</p>
            <br />
          </div>
        ) : null}
        {cart?.schedule
          ? cart.schedule.availableInstallTypes.map((installation, index) => {
              if (installation === OPTION_PRO_INSTALL) {
                return (
                  <div key={`proInstall-${index}`} className={optionRadio === OPTION_PRO_INSTALL ? "form-check active" : "form-check"}>
                    <input
                      className='form-check-input'
                      type='radio'
                      name='scheduleSelect'
                      id='scheduleSelect1'
                      checked={schedule.optionSelected === OPTION_PRO_INSTALL ? true : false}
                      onChange={() => {
                        resetScheduleState(OPTION_PRO_INSTALL);
                        setOptionRadio(OPTION_PRO_INSTALL);
                        gtmInstallationType(OPTION_PRO_INSTALL, cart.schedule.installationCostForProfessional);
                        window.scrollTo({ top: 300, behavior: "smooth" });
                      }}
                    />
                    <label className='form-check-label' htmlFor='scheduleSelect1'>
                      <div className='radio-title'>Schedule a professional installation.</div>
                      <div className='radio-cost'>
                        <strong>
                          {cart?.schedule?.installationCostForProfessional !== "Free"
                            ? `$${cart?.schedule?.installationCostForProfessional}`
                            : cart?.schedule?.installationCostForProfessional}
                        </strong>
                      </div>
                    </label>
                  </div>
                );
              } else if (installation === OPTION_SHIP) {
                return (
                  <div key={`ship-${index}`} className={optionRadio === OPTION_SHIP ? "form-check active" : "form-check"}>
                    <input
                      className='form-check-input'
                      type='radio'
                      name='scheduleSelect'
                      id='scheduleSelect2'
                      checked={schedule.optionSelected === OPTION_SHIP ? true : false}
                      onChange={() => {
                        resetScheduleState(OPTION_SHIP);
                        setOptionRadio(OPTION_SHIP);
                        gtmInstallationType(OPTION_SHIP, cart.schedule.shippingCost);
                        window.scrollTo({ top: 300, behavior: "smooth" });
                      }}
                    />
                    <label className='form-check-label' htmlFor='scheduleSelect2'>
                      <div className='radio-title'>Ship directly to your home for self-installation (2-4 business days)</div>
                      <div className='radio-cost'>
                        <strong style={cart?.schedule?.shippingCost === "Free" ? { color: "#02ae48" } : { color: "inherit" }}>
                          {cart?.schedule?.shippingCost !== "Free" ? `$${cart.schedule.shippingCost}` : cart.schedule.shippingCost}
                        </strong>
                      </div>
                    </label>
                  </div>
                );
              } else if (installation === OPTION_STORE_PICKUP) {
                return (
                  <div key={`storePickup-${index}`} className={optionRadio === OPTION_STORE_PICKUP ? "form-check active" : "form-check"}>
                    <input
                      className='form-check-input'
                      type='radio'
                      name='scheduleSelect'
                      id='scheduleSelect3'
                      checked={schedule.optionSelected === OPTION_STORE_PICKUP ? true : false}
                      onChange={() => {
                        resetScheduleState(OPTION_STORE_PICKUP);
                        setOptionRadio(OPTION_STORE_PICKUP);
                        setStorePickupModal(true);
                        gtmInstallationType(OPTION_STORE_PICKUP, "Free");
                      }}
                    />
                    <label className='form-check-label' htmlFor='flexRadioDefault3'>
                      <div className='radio-title'>In-Store Pick-Up from any retail location.</div>
                      <div className='radio-cost'>
                        <strong style={{ color: "#02ae48" }}>Free</strong>
                      </div>
                    </label>
                  </div>
                );
              }
              return null;
            })
          : null}
        <StorePickupModal showStorePickupModal={showStorePickupModal} setStorePickupModal={setStorePickupModal} />
      </div>
      {(optionRadio === OPTION_PRO_INSTALL && appointments?.schedules?.nonSecuritySchedule?.availableAppointments.length > 0) ||
      (optionRadio === OPTION_PRO_INSTALL && appointments?.schedules?.securitySchedule?.availableAppointments.length > 0) ? (
        <div className='customer-instruction-box'>
          {/* Displaying customer instructions */}
          <div>
            <strong>Choose a date and time for your installation. Please make sure someone over the age of 18 is present.</strong>
          </div>
          <small>*Installation times may vary based on the scope of work.</small>
        </div>
      ) : null}
      {/* Calendar button will be displayed for NON SECURITY Products if OPTION_PRO_INSTALL is selected */}
      {optionRadio === OPTION_PRO_INSTALL && appointments?.schedules?.nonSecuritySchedule?.availableAppointments.length > 0 ? (
        <div className='service-installation-container'>
          <CalendarButton
            appointments={appointments.schedules.nonSecuritySchedule.availableAppointments}
            label='Select Date and Time'
            scheduleType={SCHEDULE_TYPE_NON_SECURITY}
          />
        </div>
      ) : null}
      {/* Calendar button will be displayed for SECURITY Products if OPTION_PRO_INSTALL is selected */}
      {optionRadio === OPTION_PRO_INSTALL && appointments?.schedules?.securitySchedule?.availableAppointments.length > 0 ? (
        <div className='service-installation-container'>
          <CalendarButton
            appointments={appointments.schedules.securitySchedule.availableAppointments}
            label='Select Date and Time for Security Products'
            scheduleType={SCHEDULE_TYPE_SECURITY}
          />
        </div>
      ) : null}
      {optionRadio === OPTION_SHIP ? <ShippingAddressForm cart={cart} /> : null}
    </>
  );
};

export default ScheduleRadioButtons;
